
// let DEFAULT_BASE_API = 'http://localhost:8080/api/'
let DEFAULT_BASE_API = 'https://terminmasterapi.in.rs/api/'
let DYNAMIC_BASE_API_KEY = 'DYNAMIC_BASE_API';

function normalizeBaseApi(url) {
    if(url == null || url.length <= 0) return null;
    return url.endsWith('/') ? url : url + '/';
}

function getBaseApi() {
    let dynamicBaseApi = localStorage.getItem(DYNAMIC_BASE_API_KEY);
    return dynamicBaseApi != null && dynamicBaseApi.length > 0 ? dynamicBaseApi : DEFAULT_BASE_API;
}

function saveDynamicBaseApi(url) {
    let normalizedUrl = normalizeBaseApi(url);
    if(normalizedUrl == null) return;
    localStorage.setItem(DYNAMIC_BASE_API_KEY, normalizedUrl);
}

function removeDynamicBaseApi() {
    localStorage.removeItem(DYNAMIC_BASE_API_KEY);
}

export { getBaseApi, saveDynamicBaseApi, removeDynamicBaseApi }
export default DEFAULT_BASE_API



// WEBPACK FOOTER //
// ./src/services/BaseApi.js